import { cn } from "@/shared/lib/utils";
import type { ReactNode } from "react";

export type StatusPillVariant = "green" | "blue" | "amber" | "red" | "slate";

export interface StatusPillProps {
  variant: StatusPillVariant;
  children: ReactNode;
  testId?: string | undefined;
  className?: string | undefined;
}

const VARIANT_CLASSES: Record<StatusPillVariant, string> = {
  green: "bg-[hsl(var(--status-green-bg))] text-[hsl(var(--status-green-fg))]",
  blue: "bg-[hsl(var(--status-blue-bg))] text-[hsl(var(--status-blue-fg))]",
  amber: "bg-[hsl(var(--status-amber-bg))] text-[hsl(var(--status-amber-fg))]",
  red: "bg-[hsl(var(--status-red-bg))] text-[hsl(var(--status-red-fg))]",
  slate: "bg-[hsl(var(--status-slate-bg))] text-[hsl(var(--status-slate-fg))]",
};

/** Solidní barevné status označení. Bez průhlednosti, bez glass efektu. */
export function StatusPill({ variant, children, testId, className }: StatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        VARIANT_CLASSES[variant],
        className,
      )}
      data-testid={testId}
    >
      {children}
    </span>
  );
}
